var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: {
                  title: _vm.$t("message.adminContractPartnerList.title"),
                  icon: "ti-agenda"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                {
                  staticClass: "rounded-0",
                  attrs: {
                    title: _vm.$t(
                      "message.adminContractPartnerList.card.title.contractPartners"
                    )
                  }
                },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      fields: _vm.fields,
                      items: _vm.contractPartners
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "address",
                        fn: function(data) {
                          return [
                            _c("address", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(data.item.street) +
                                    " " +
                                    _vm._s(data.item.streetNumber)
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                data.item.postalCode
                                  ? _c("span", [
                                      _vm._v(_vm._s(data.item.postalCode))
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(data.item.postOfficeBox))
                                    ]),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(data.item.city) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(data.item.country))])
                            ])
                          ]
                        }
                      },
                      {
                        key: "actions",
                        fn: function(data) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-row" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass: "ml-auto btn-action",
                                    attrs: { variant: "link" },
                                    on: {
                                      click: function($event) {
                                        _vm.showDetails(data)
                                      }
                                    }
                                  },
                                  [_c("span", { staticClass: "ti-files" })]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                {
                  staticClass: "rounded-0",
                  attrs: {
                    title: _vm.$t(
                      "message.adminContractPartnerList.card.title.contractPartnerTemplates"
                    )
                  }
                },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      fields: _vm.fields,
                      items: _vm.contractPartnerTemplates
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "address",
                        fn: function(data) {
                          return [
                            _c("address", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(data.item.street) +
                                    " " +
                                    _vm._s(data.item.streetNumber)
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                data.item.postalCode
                                  ? _c("span", [
                                      _vm._v(_vm._s(data.item.postalCode))
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(data.item.postOfficeBox))
                                    ]),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(data.item.city) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(data.item.country))])
                            ])
                          ]
                        }
                      },
                      {
                        key: "actions",
                        fn: function(data) {
                          return [
                            _c("div", { staticClass: "d-flex flex-row" }, [
                              _c(
                                "div",
                                { staticClass: "ml-auto" },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "btn-action",
                                      attrs: { variant: "link" },
                                      on: {
                                        click: function($event) {
                                          _vm.showContractPartnerTemplate(data)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "ti-pencil-alt"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b446d896", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b446d896","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminContractPartnerList.vue
// module id = S08r
// module chunks = 1